import React, {useEffect} from 'react';
import './DataTable.css';
import {useConfiguration} from "src/contexts/ConfigurationContext";
import {DataItem} from "src/types/configuration";

const DataTable: React.FC = () => {
    const {state, calculation} = useConfiguration();
    const [data, setData] = React.useState<DataItem[]>([]);

    useEffect(() => {
        setTimeout(() => {
            setData(calculation
                .getData()
                .filter((row: DataItem) => row && row.quantity > 0));
        }, 600);
    }, [state, calculation, setData]);

    return (
        <div className="data-table">
            <table>
                <thead>
                <tr>
                    <th>Materiaal</th>
                    <th>Eenheid</th>
                    <th>Aantal</th>
                    <th>Prijs</th>
                    <th>Totaal</th>
                </tr>
                </thead>
                <tbody>
                {data.map((row: DataItem, index: number) => {
                    if (!row) return null;
                    return (
                        <tr key={index}>
                            <td>{row.label}</td>
                            <td>{row.unit}</td>
                            <td>{calculation.roundValue(row.quantity)}</td>
                            <td>{row.price ? calculation.formatToCurrency(row.price) : ""}</td>
                            <td>{row.total ? calculation.formatToCurrency(row.total) : ""}</td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
            <div className="total-price">
                <span>Totaal prijs .incl. BTW</span>
                <span>{calculation.getFormatTotalPrice()}</span>
            </div>
        </div>
    );
};

export default DataTable;
